import React, { useEffect, useState } from "react";
// import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import NewExpense from "./NewExpense";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// import { RotateCcw } from "feather-icons-react/build/IconComponents";
// import { Edit } from "feather-icons-react/build/IconComponents";
import { Spin, Tooltip } from "antd";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import axios from "axios";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import EditExpense from "./EditExpenses";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CRMExpenses = () => {
  const columns = [
    {
      title: "Reason",
      dataIndex: "expense_name",
      sorter: (a, b) =>
        (a.expense_name || "").localeCompare(b.expense_name || ""),
      render: (text) => {
        if (!text) return "N/A";

        const shortText =
          text.length > 24 ? `${text.substring(0, 24)}...` : text;

        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Customer",
      dataIndex: "client_name",
      sorter: (a, b) =>
        (a.client_name || "").localeCompare(b.client_name || ""),
      render: (text) => {
        if (!text) return "N/A";

        const shortText =
          text.length > 24 ? `${text.substring(0, 24)}...` : text;

        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Category",
      dataIndex: "expense_category_name",
      sorter: (a, b) =>
        (a.expense_category_name || "").localeCompare(
          b.expense_category_name || "",
        ),
      render: (_, record) => {
        const expense_category_name = record.expense_category_name || "N/A";

        const truncatedNote =
          expense_category_name.length > 40
            ? `${expense_category_name.substring(0, 40)}...`
            : expense_category_name;

        return (
          <div className="d-flex align-items-start">
            <div className="ms-3">
              <div className="fw-semibold" title={expense_category_name}>
                {truncatedNote}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-user me-2"></i>
                {record.addedfrom_name || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },
    {
      title: "Date",
      sorter: (a, b) => {
        const dateA = dayjs(a.date);
        const dateB = dayjs(b.date);

        return dateA.valueOf() - dateB.valueOf();
      },
      render: (_, record) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>

            {record.date ? dayjs(record.date).format("DD-MM-YYYY") : "N/A"}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-credit-card me-2"></i>
            {record.payment_mode_name || "N/A"}
          </small>
        </>
      ),
    },

    {
      title: "Expense Note",
      dataIndex: "note",
      sorter: (a, b) => (a.note || "").localeCompare(b.note || ""),
      render: (note) => {
        if (!note) return "N/A";

        const shortText =
          note.length > 24 ? `${note.substring(0, 24)}...` : note;

        return (
          <Tooltip title={note}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => Number(a.amount || 0) - Number(b.amount || 0),
      render: (amount) => (
        <span className="fw-bold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
          {amount}
        </span>
      ),
    },

    {
      title: "Receipt",
      width: 70,
      dataIndex: "external_link",

      // Sorting is not useful for receipt icon
      render: (text) => {
        if (!text) return "N/A";

        return (
          <i
            className="fa-solid fa-receipt"
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#1677ff",
            }}
            title="View Receipt"
            onClick={() => window.open(text, "_blank", "noopener,noreferrer")}
          />
        );
      },
    },

    {
      title: "Action",
      width: 70,

      // No sorting for action
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              title="Edit"
              onClick={(e) => {
                e.preventDefault();
                handleEditExpense(record);
              }}
              className="text-primary me-2 p-2"
            >
              <i className="ti ti-pencil text-primary"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const [expensesData, setExpensesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expensesCounts, setExpensesCounts] = useState({
    Total: "0",
    Billable: "0",
    NonBillable: "0",
    NotInvoiced: "0",
  });
  const [expenseDrawerOpen, setExpenseDrawerOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const handleExpenseClose = () => {
    setExpenseDrawerOpen(false);
  };

  const fetchExpensesCounts = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}expenses/GetExpenseCounts`);

      const data = await response.json();

      if (data?.Status) {
        setExpensesCounts(data.ResultData?.[0] || {});
      }
    } catch (error) {
      console.error("Get Estimate Counts Error:", error);
    }
  };

  const getExpenses = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}expenses/GetExpenses`);

      if (response.data.Status) {
        setExpensesData(response.data.ResultData || []);

        fetchExpensesCounts();
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No expenses found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("expenses API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getExpenses();
    fetchExpensesCounts();
  }, []);

  const [editExpenseOpen, setEditExpenseOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const handleEditExpense = (record) => {
    setSelectedExpense(record);
    setEditExpenseOpen(true);
  };

  const handleCloseEditExpense = () => {
    setEditExpenseOpen(false);
    setSelectedExpense(null);
  };

  const exportExpensesExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Expenses");

      // Columns
      worksheet.columns = [
        {
          header: "Category",
          key: "expense_category_name",
          width: 20,
        },
        {
          header: "Expense Name",
          key: "expense_name",
          width: 30,
        },
        {
          header: "Client",
          key: "client_name",
          width: 30,
        },
        {
          header: "Amount",
          key: "amount",
          width: 15,
        },

        {
          header: "Tax 1",
          key: "taxName",
          width: 15,
        },
        {
          header: "Tax 1 Value",
          key: "tax",
          width: 15,
        },
        {
          header: "Tax 2",
          key: "taxName2",
          width: 15,
        },
        {
          header: "Tax 2 Value",
          key: "tax2",
          width: 15,
        },
        {
          header: "Payment Mode",
          key: "payment_mode_name",
          width: 18,
        },

        {
          header: "Date",
          key: "date",
          width: 20,
        },
        {
          header: "Added By",
          key: "addedfrom_name",
          width: 22,
        },
        {
          header: "Reference No",
          key: "reference_no",
          width: 25,
        },
      ];

      // Add data
      expensesData.forEach((expense) => {
        worksheet.addRow({
          expense_category_name: expense.expense_category_name ?? "",

          expense_name: expense.expense_name ?? "",

          client_name: expense.client_name ?? "",

          amount: expense.amount ?? "",

          taxName: expense.taxName || "N/A",

          tax: expense.tax ?? "",

          taxName2: expense.taxName2 || "N/A",

          tax2: expense.tax2 ?? "",

          payment_mode_name: expense.payment_mode_name || "N/A",

          date: expense.date
            ? new Date(expense.date).toLocaleDateString("en-IN")
            : "",

          addedfrom_name: expense.addedfrom_name || "N/A",

          reference_no: expense.reference_no || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Expenses.xlsx");
    } catch (error) {
      console.error("Expenses Excel export error:", error);

      Swal.fire("Error", "Failed to generate Expenses Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportExpensesPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Category",
        "Expense Name",
        "Client",
        "Amount",
        "Tax 1",
        "Tax 1 Value",
        "Tax 2",
        "Tax 2 Value",
        "Payment Mode",
        "Date",
        "Added By",
        "Reference No",
      ];

      const rows = expensesData.map((expense) => [
        expense.expense_category_name ?? "",

        expense.expense_name ?? "",

        expense.client_name ?? "",

        expense.amount ?? "",

        expense.taxName || "N/A",

        expense.tax ?? "",

        expense.taxName2 || "N/A",

        expense.tax2 ?? "",

        expense.payment_mode_name || "N/A",

        expense.date ? new Date(expense.date).toLocaleDateString("en-IN") : "",

        expense.addedfrom_name || "N/A",

        expense.reference_no || "N/A",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Expenses Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 5,
          right: 5,
        },

        theme: "grid",

        styles: {
          fontSize: 5.5,
          cellPadding: 1.5,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 6,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        // Footer
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Expenses.pdf");
    } catch (error) {
      console.error("Expenses PDF export error:", error);

      Swal.fire("Error", "Failed to generate Expenses PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="d-flex justify-content-between mb-2">
          {/* Left section with heading and description */}
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Expenses
                </h4>
              </ol>
            </nav>
            <p className="text-muted">Manage and add new Expenses here </p>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <ul className="table-top-head d-flex align-items-center mb-0">
              <li className="me-2">
                <Link onClick={exportExpensesPDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </li>
              <li className="me-2">
                <Link onClick={exportExpensesExcel}>
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </li>
              {/* <li>
                <Link>
                  <RotateCcw />
                </Link>
              </li> */}
            </ul>

            <div className="page-btn ms-2">
              <Link
                to="#"
                className="btn btn-success btn-sm"
                onClick={(e) => {
                  e.preventDefault();
                  setExpenseDrawerOpen(true);
                }}
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
            {/* <div className="page-btn ms-2">
              <Link
                to="#"
                className="btn btn-secondary color"
                data-bs-toggle="modal"
                data-bs-target="#view-notes"
              >
                <FeatherIcon icon="upload" className="me-2" />
                Import
              </Link>
            </div> */}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div className="card flex-fill shadow-sm ">
              <div className=" card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">₹ {expensesCounts?.Total}</h4>
                  <p className="fw-semibold">Total</p>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center text-info"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-layer-group fs-16" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body  d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">₹ {expensesCounts?.Billable}</h4>
                  <p className="fw-semibold">Billable</p>
                </div>
                {/* <span className="revenue-icon bg-teal-transparent text-teal"></span> */}
                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center text-success"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-address-card fs-15" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body  d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    ₹ {expensesCounts?.NonBillable}
                  </h4>
                  <p className="fw-semibold">Non Billable</p>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center text-warning"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="ti ti-hash fs-16" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body  d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    ₹ {expensesCounts?.NotInvoiced}
                  </h4>
                  <p className="fw-semibold">Not Invoiced</p>
                </div>
                <span className="revenue-icon bg-orange-transparent text-orange"></span>
                <div
                  className="rounded-circle bg-dark bg-opacity-10 d-flex align-items-center justify-content-center text-dark"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa fa-user-plus fs-16" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card table-list-card" style={{ marginTop: "-1rem" }}>
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="btn btn-white btn-md d-inline-flex align-items-center"
                >
                  <i className="ti ti-filter me-1"></i>
                </Link>
              </div> */}
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={expensesData} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      <NewExpense
        open={expenseDrawerOpen}
        onClose={handleExpenseClose}
        getExpenses={getExpenses}
      />
      <EditExpense
        open={editExpenseOpen}
        onClose={handleCloseEditExpense}
        getExpenses={getExpenses}
        record={selectedExpense}
      />
    </div>
  );
};

export default CRMExpenses;
